import React, { useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import { Form, Input, Radio, Upload, message } from "antd";
import { FormDataProps, FormItemSectionProps } from ".";
import CountryDropdown from "@/components/App/CountryDropdown";
import { RcFile } from "antd/lib/upload";
import { post_upload } from "@/api/xt-user";
import { waitRes } from "@/utils/axios";
import XtLoading from "@/components/Xt/Loading";
export interface UplodaApiResProps extends ObjAny {
  absolutePath: string;
  fileName: string;
}
interface FormItemCompProps extends BaseCompProps {
  attr?: any;
  index: number; // 表单数组数据索引，用来name使用匹配
  formData: FormDataProps;
  uploadChange?(data: UplodaApiResProps, type: "cardFront" | "cardBack", index: number): void; // 手动上传文件后台返回结果之后的更改事件
}
type ItemProps = keyof FormItemSectionProps;
const { useTranslation } = Hooks;
const FormItemSection: React.FC<FormItemCompProps> = ({ className, index, formData, uploadChange }) => {
  const t = useTranslation();
  const { ents } = formData;
  //const {isLogin} = store.user;
  const [loading, setLoading] = useState({ cardFront: false, cardBack: false });
  /**useMemo */
  const rules = useMemo(() => {
    return {
      firstName: [{ required: true, message: t("ent.plsInput") }],
      lastName: [{ required: true, message: t("ent.plsInput") }],
      email: [
        { required: true, message: t("ent.plsInput") },
        { pattern: /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: t("ent.inputError") },
      ],
      mobile: [
        { required: true, message: t("ent.plsInput") },
        { pattern: /^[0-9]+$/, message: t("ent.inputError") },
      ],
      position: [{ required: true, message: t("ent.plsInput") }],
      cardFront: [{ required: true, message: t("ent.plsInput") }],
      cardBack: [{ required: true, message: t("ent.plsInput") }],
    };
  }, []);

  const getName = useMemo(() => {
    return (prop: ItemProps) => {
      return ["ents", index, prop];
    };
  }, [index]);

  /**method */
  const beforeUpload = (file: RcFile, type: "cardFront" | "cardBack") => {
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) return message.error(t("ent.uploadFileLimit", [5]));
    uploadFile(file, type);
  };
  const uploadFile = async (file: RcFile, type: "cardFront" | "cardBack") => {
    const newLoading = { ...loading, [type]: true };
    setLoading(newLoading);
    const { data, err } = await waitRes(post_upload, file);
    setLoading({ ...loading, [type]: false });
    if (!data || !data.absolutePath || err) return;
    uploadChange && uploadChange(data, type, index);
  };
  return (
    <div className={cx(styles["page-account-enterprise-p2-from"], className)}>
      <div className={styles["page-account-enterprise--form"]}>
        <section>
          <Form.Item label={t("ent.name")} name={getName("firstName")} rules={rules.firstName}>
            <Input placeholder={t("ent.plsInput")} maxLength={50} />
          </Form.Item>
          <Form.Item label={t("ent.email")} name={getName("email")} rules={rules.email}>
            <Input placeholder={t("ent.plsInput")} maxLength={50} />
          </Form.Item>
          <Form.Item label={t("ent.position")} name={getName("position")} rules={rules.position}>
            <Input placeholder={t("ent.plsInput")} maxLength={50} />
          </Form.Item>
          <p className={styles["page-account-enterprise--subNav"]}>{t("ent.uploadIdFile")}</p>
          <Form.Item label={t("ent.cardTypeSelect")} name={getName("cardType")}>
            <Radio.Group>
              <Radio value={2}>{t("account.passport")}</Radio>
              <Radio value={1}>{t("account.idCard")}</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label={t("ent.cardCountry")} name={getName("cardCountryId")}>
            <CountryDropdown selectProps="id" />
          </Form.Item>
        </section>
        <div className={styles["page-account-enterprise--formSplit"]}></div>
        <section>
          <Form.Item label={t("ent.firstName")} name={getName("lastName")} rules={rules.lastName}>
            <Input placeholder={t("ent.plsInput")} maxLength={50} />
          </Form.Item>
          <Form.Item label={t("ent.tel")}>
            <div className={styles["tel-ctn"]}>
              <Form.Item noStyle name={getName("mobileCountryId")}>
                <CountryDropdown
                  selectProps="id"
                  label={(item) => (
                    <>
                      <span>+</span>&nbsp;
                      <span style={{ fontSize: "13px" }}>{item?.code || t("cmpt.select")}</span>
                    </>
                  )}
                />
              </Form.Item>
              <Form.Item name={getName("mobile")} rules={rules.mobile} noStyle>
                <Input type="tel" placeholder={t("ent.plsInput")} maxLength={16} />
              </Form.Item>
            </div>
          </Form.Item>
          <Form.Item label={t("ent.countryCode")} name={getName("countryId")}>
            <CountryDropdown selectProps="id" />
          </Form.Item>
        </section>
      </div>

      <section className={styles["upload-ctn"]}>
        {/* 上传正面 */}
        <div className={styles["upload-front"]}>
          <Form.Item
            name={getName("cardFront")}
            noStyle
            valuePropName="file"
            getValueFromEvent={(e) => (Array.isArray(e) ? e : e.file)}
            rules={rules.cardFront}
          >
            <Upload
              showUploadList={false}
              accept=".jpg,.jpeg,.png"
              beforeUpload={(file) => {
                beforeUpload(file, "cardFront");
                return false;
              }}
            >
              <div className={styles["iImg"]}>
                {loading.cardFront && <XtLoading />}
                {ents[index].cardFront && typeof ents[index].cardFront === "string" ? (
                  <img src={ents[index].cardFront} alt="" />
                ) : (
                  <div>
                    {!store.app.isDark && <img src={require("@/assets/images/account/a-file-id-1.png").default} alt="" />}
                    {store.app.isDark && <img src={require("@/assets/images/account/a-file-id-1-night.png").default} alt="" />}
                    <img src={require("@/assets/images/account/a-file-add.png").default} alt="" />
                  </div>
                )}
              </div>
            </Upload>
          </Form.Item>
          <p className={styles["iTitle"]}>{t("ent.clickToAddCardFront")}</p>
          <div className={styles["iDesc"]}>{t("ent.clickToAddCardTip")}</div>
        </div>
        {/* 上传背面 */}
        <div className={styles["upload-back"]}>
          <Form.Item name={getName("cardBack")} noStyle valuePropName="file" getValueFromEvent={(e) => (Array.isArray(e) ? e : e.file)} rules={rules.cardBack}>
            <Upload
              showUploadList={false}
              accept=".jpg,.jpeg,.png"
              beforeUpload={(file) => {
                beforeUpload(file, "cardBack");
                return false;
              }}
            >
              <div className={styles["iImg"]}>
                {loading.cardBack && <XtLoading />}
                {ents[index].cardBack && typeof ents[index].cardBack === "string" ? (
                  <img src={ents[index].cardBack} alt="" />
                ) : (
                  <div>
                    {!store.app.isDark && <img src={require("@/assets/images/account/a-file-id-2.png").default} alt="" />}
                    {store.app.isDark && <img src={require("@/assets/images/account/a-file-id-2-night.png").default} alt="" />}
                    <img src={require("@/assets/images/account/a-file-add.png").default} alt="" />
                  </div>
                )}
              </div>
            </Upload>
          </Form.Item>
          <p className={styles["iTitle"]}>{t("ent.clickToAddCardBack")}</p>
          <div className={styles["iDesc"]}>{t("ent.clickToAddCardTip")}</div>
        </div>
      </section>
    </div>
  );
};
export default observer(FormItemSection);
